(function () {
  'use strict';
  function initialise(root) {
    var gallery = root.querySelector('[data-ffc-pc-gallery]');
    if (!gallery || gallery.dataset.galleryReady) return;
    var data;
    try { data = JSON.parse(gallery.querySelector('[data-ffc-gallery-data]').textContent); }
    catch (_) { return; }
    var images = (data.images || []).filter(function (m) { return m.preview_image && m.preview_image.src; });
    if (!images.length) return;
    gallery.dataset.galleryReady = 'true';
    var index = data.index || { colours: {}, media: {} };
    var colour = gallery.dataset.initialColour || '';
    var active = -1;
    var currentImage = null;
    var visible = images.filter(function (image) {
      var meta = (index.media || {})[String(image.id)];
      if (meta && meta.view) return /^(model|lifestyle)$/i.test(meta.view);
      var filename = new URL(image.preview_image.src, location.href).pathname.split('/').pop();
      filename = decodeURIComponent(filename).replace(/_20/g, ' ');
      return /(?:^|[\s_-])(?:model|lifestyle)(?:[\s_.-]|\d|$)/i.test(filename) ||
        /(?:^|\s[-–|]\s)(?:model|lifestyle)(?:\s+\d+)?$/i.test(image.alt || '');
    });
    var main = gallery.querySelector('[data-ffc-pc-main-image]');
    var thumbs = gallery.querySelector('[data-ffc-gallery-thumbnails]');
    var open = gallery.querySelector('[data-ffc-gallery-open]');
    var dialog = gallery.querySelector('[data-ffc-gallery-dialog]');
    var zoom = gallery.querySelector('[data-ffc-gallery-zoom-image]');
    var previousFocus;
    function url(image, width) {
      var result = new URL(image.preview_image.src, location.href);
      result.searchParams.set('width', String(width));
      return result.href;
    }
    function label(image) {
      var meta = (index.media || {})[String(image.id)];
      return meta && meta.view ? (meta.colour ? meta.colour + ' - ' : '') + meta.view.charAt(0).toUpperCase() + meta.view.slice(1) : (image.alt || data.title);
    }
    function imageIdForUrl(source) {
      if (!source) return null;
      var target = new URL(source, location.href).pathname;
      var match = images.find(function (image) { return new URL(image.preview_image.src, location.href).pathname === target; });
      return match && match.id;
    }
    function display(image, scroll) {
      currentImage = image || null;
      active = image ? visible.indexOf(image) : -1;
      main.hidden = !image;
      open.disabled = !image;
      gallery.querySelector('[data-ffc-gallery-empty]').hidden = !!image;
      gallery.querySelector('.ffc-gallery__zoom-icon').hidden = !image;
      if (image) { main.src = url(image, 1000); main.alt = label(image); }
      var caption = image ? label(image) + (active >= 0 ? ' (' + (active + 1) + ' / ' + visible.length + ')' : '') : '';
      gallery.querySelector('[data-ffc-gallery-caption]').textContent = caption;
      gallery.querySelector('[data-ffc-gallery-dialog-caption]').textContent = caption;
      if (dialog.open && image) { zoom.src = url(image, 2000); zoom.alt = label(image); }
      if (dialog.open && !image) dialog.close();
      Array.prototype.forEach.call(thumbs.children, function (button, i) {
        button.setAttribute('aria-pressed', String(i === active));
        if (scroll && i === active) thumbs.scrollLeft = button.offsetLeft - thumbs.offsetLeft - thumbs.clientWidth / 2 + button.clientWidth / 2;
      });
      gallery.querySelectorAll('[data-ffc-gallery-prev], [data-ffc-gallery-next]').forEach(function (button) { button.disabled = !visible.length || (visible.length === 1 && active === 0); });
    }
    function show(position, scroll) {
      if (visible.length) display(visible[(position + visible.length) % visible.length], scroll);
    }
    function move(direction) {
      show(active < 0 ? (direction > 0 ? 0 : visible.length - 1) : active + direction, true);
    }
    function findImage(id) {
      return images.find(function (image) { return String(image.id) === String(id); });
    }
    function render() {
      thumbs.replaceChildren();
      visible.forEach(function (image, i) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'ffc-gallery__thumbnail';
        button.setAttribute('aria-label', label(image));
        button.title = label(image);
        var img = document.createElement('img');
        img.src = url(image, 160); img.alt = ''; img.width = 66; img.height = 78; img.loading = 'lazy';
        button.appendChild(img);
        button.addEventListener('click', function () { show(i, false); });
        button.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          show(i + (event.key === 'ArrowRight' ? 1 : -1), true);
          thumbs.children[active].focus({ preventScroll: true });
        });
        thumbs.appendChild(button);
      });
      gallery.querySelector('[data-ffc-gallery-controls]').hidden = !visible.length;
      thumbs.hidden = !visible.length;
    }
    root.addEventListener('ffc:colour-change', function (event) {
      colour = event.detail.colour;
      var group = (index.colours || {})[colour];
      display(findImage(group && group.primary) || findImage(imageIdForUrl(event.detail.image)), false);
    });
    gallery.querySelectorAll('[data-ffc-gallery-prev]').forEach(function (button) { button.addEventListener('click', function () { move(-1); }); });
    gallery.querySelectorAll('[data-ffc-gallery-next]').forEach(function (button) { button.addEventListener('click', function () { move(1); }); });
    open.addEventListener('click', function () {
      previousFocus = document.activeElement;
      dialog.showModal();
      display(currentImage, false);
      gallery.querySelector('[data-ffc-gallery-close]').focus();
    });
    gallery.querySelector('[data-ffc-gallery-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', function () { if (previousFocus) previousFocus.focus({ preventScroll: true }); });
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
      }
    });
    var initialGroup = (index.colours || {})[colour];
    var initialModel = visible.find(function (image) { return ((index.media || {})[String(image.id)] || {}).colour === colour; });
    render();
    display(initialModel || visible[0] || findImage(initialGroup && initialGroup.primary) || findImage(imageIdForUrl(main.src)) || images[0], false);
  }
  function scan(scope) {
    if (scope.matches && scope.matches('[data-ffc-pc]')) initialise(scope);
    scope.querySelectorAll('[data-ffc-pc]').forEach(initialise);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); });
  else scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
}());
